import { BaseService, type ResponseMessage } from "@kiddocare-platform/portal-common/base";
import type { FrequentQuestion } from "@kiddocare-platform/portal-common/hub";

export class HubKiddyService extends BaseService {

  public async Like(idChat: string, identifier: string) {
    try {
      const response = await this.AxiosInstance.get(`/parent/kiddy/likeAnswer/${idChat}/${identifier}`);
      return response.data;
    } catch (error: any) {
      this.log.error("Like", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async Unlike(idChat: string, identifier: string) {
    try {
      const response = await this.AxiosInstance.get(`/parent/kiddy/unlikeAnswer/${idChat}/${identifier}`);
      return response.data;
    } catch (error: any) {
      this.log.error("Unlike", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async FrequentQuestion(): Promise<ResponseMessage<Array<FrequentQuestion>>> {
    try {
      const response = await this.AxiosInstance.get(`/parent/kiddy/frequentQuestions`);
      return response.data;
    } catch (error: any) {
      this.log.error("Questions", error.stack, JSON.stringify(error));
      throw error.response?.data ? error.response.data : error;
    }
  }

  public async Message(
    question: string,
    typeQuestion: "APP" | "FREQUENT",
    idChat: string,
  ): Promise<ResponseMessage<{
    id?: string | bigint;
    identifier?: string;
    content?: string;
    answer?: string;
    message?: string;
  }>> {
    try {
      const response = await this.AxiosInstance.post(`/parent/kiddy/message`, {
        question,
        typeQuestion,
        idChat,
      });
      return response.data;
    } catch (error: any) {
      this.log.error("Message", error.stack, JSON.stringify(error));
      throw error.response?.data ? error.response.data : error;
    }
  }

  public async CreateChat(): Promise<ResponseMessage<{ idChat?: string; message?: string } | string>> {
    try {
      const response = await this.AxiosInstance.post(`/parent/kiddy/createChat`);
      return response.data;
    } catch (error: any) {
      this.log.error("CreateChat", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async CloseChat(idChat: string) {
    try {
      const response = await this.AxiosInstance.put(`/parent/kiddy/closeChat/${idChat}`);
      return response.data;
    } catch (error: any) {
      this.log.error("CloseChat", error.stack, JSON.stringify(error));
      throw error;
    }
  }

}
